const brand = {
  key: 'monnaiedeParis',
  path: 'monnaie-de-paris',
  name: 'Monnaie de Paris',
  accessKey: process.env.REACT_APP_MONNAIE_DE_PARIS_ACCESS_KEY,
  url: 'https://www.monnaiedeparis.fr',

  features: {
    withUidCheck: false,
    withReferenceInput: true,
    withIssueRequest: true,
    withTextRecognition: false,
  },
  images: {
    logo: 'https://res.cloudinary.com/dnkj85yan/image/upload/v1686237714/certificate-request-page/brands/monnaie%20de%20paris/logo_waq9rz.png',
    homePage: null,
    homePageCompressed: null,
    certificateExample:
      'https://res.cloudinary.com/dnkj85yan/image/upload/v1700493098/Photos/MdP/Eiffel%20Collection/Visuel_-_Certificat_PDF_final_mzzk7c.png',
    certificateExampleCompressed:
      'https://res.cloudinary.com/dnkj85yan/image/upload/v1700493126/Visuel_-_Certificat_PDF_final_mzzk7c_e7l9oe.jpg',

    favicon:
      'https://res.cloudinary.com/dnkj85yan/image/upload/v1686237713/certificate-request-page/brands/monnaie%20de%20paris/favicon_gaojb4.png',
    uidExample: null,
  },
};

export default brand;
